import AppError from './models/common/res/AppError';
import { request, Row } from './request';
import { Partner } from './models/partner/res/Partner';
import { PartnerCustomer } from './models/partner/res/PartnerCustomer';
import LANGUAGE_MAPPER from '../constants/language-mapper.constants';

export const fetchPartner = async (
  partnerId: number | string,
  languageCode?: string,
) => {
  const url = `/app/partners/${partnerId}`;
  let mappedLanguageCode = languageCode;
  if (languageCode && LANGUAGE_MAPPER[languageCode]) {
    mappedLanguageCode = LANGUAGE_MAPPER[languageCode];
  }
  try {
    const { data } = await request<Row<Partner>>({
      method: 'get',
      url,
      queryParams: {
        languageCode: mappedLanguageCode,
      },
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

export const verifyToken = async (token: string) => {
  const url = `/mini-web/token`;
  try {
    const { data } = await request<Row<PartnerCustomer>>({
      method: 'get',
      url,
      headers: {
        Authorization: token,
      },
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};
